const _tund = 'undefined';
const _tfn = 'function';
const _tstr = 'string';
const _tobj = 'object';
const _tnum = 'number';
const _tbool = 'boolean';

export default {
    // VARIABLES INFO
    exist(va, type) {
        const t = typeof va;

        return typeof type === _tstr ? t === type : t !== _tund;
    },

    isArray(va) {
        return va instanceof Array;
    },

    isDate(va) {
        return va instanceof Date;
    },

    // Check sulla variabile
    // restituisce FALSE se la variabile non e' definita, se e' una stirnga vuota, 0, NaN, null, un oggetto Date non valido o false.
    valued(va) {
        if (this.isDate(va)) return this.valid(va.getTime());

        return this.exist(va) ? Boolean(va) : !1;
    },

    // Check sulla variabile (numero stringa)
    // restituisce FALSE se la variabile non e' definita.
    // o se e' un oggetto Date non valido
    // o se la variabile e' NULL
    // o se la variabile e' un numero ma e' NaN
    // o se alla variaible e' assegnata una funzione/classe
    // in tutti gli altri casi ritorna true (anche se e' 0 o stringa vuota)
    valid(va) {
        if (this.isDate(va)) {
            return this.valid(va.getTime());
        }

        switch (typeof va) {
            case _tund:
            case _tfn:
                return !1;
            case _tstr:
                return !0;
            case _tobj:
                return Boolean(va);
            case _tnum:
                return Boolean(va) || va === 0;
            default:
                return !0;
        }
    },

    // MIXED TOOLS

    // cleanURL
    // restituisce la url senza querystring ne hashtag
    // url - se non presente viene utilizzata la location href
    cleanURL(_URL) {
        if (!this.exist(_URL, _tstr)) _URL = location.href;

        return _URL.replace(/[?#].*$/, '');
    },

    // Query string cactch
    // prelevo uno o tutti i parametri dalla querystring
    // url - se non presente viene utilizzata la location href
    getUrlParams(key, _URL) {
        const ck = this.exist(key, _tstr);

        if (!ck) key = '([^=?#&]*)';
        if (!this.exist(_URL, _tstr)) _URL = location.href;
        const re = new RegExp('[?&]' + key + '=?([^?#&]*)', 'g');
        let m;
        const _obj = {};
        let _x = !1;

        while ((m = re.exec(_URL)) !== null) {
            if (ck) return this.valued(m[1]) ? m[1] : '';
            if (!this.valued(m[1])) continue;
            _obj[m[1]] = this.valued(m[2]) ? m[2] : '';
            _x = !0;
        }

        return _x ? _obj : null;
    },

    // STORAGE

    // estraggo il valore di un cookie
    // se il cookie non e' presente ritorna una stringa vuota
    // patametro 1: "nome cookie" [stringa]
    // parametro 2: "applicazione decode URI" [true/false]
    getCookie(name, decode) {
        try {
            if (!this.exist(decode, _tbool)) decode = false;
            const ex = RegExp('(?:^|; )' + name + '=([^;]*)');
            const mt = document.cookie.match(ex);

            return mt ? (decode ? decodeURIComponent(mt[1]) : mt[1]) : null;
        } catch (_) {
            return null;
        }
    },

    // Aggiungo un nuovo cookie
    // ritorno true se il processo e' completo
    // false in caso di errore
    // name: name cookie [string] [requered]
    // va: valore cookie [string] [requered]
    // ex: expire in giorni [number]
    // dom: dominio di appartenenza del cookie [string]
    // path: path di validita' del cookie
    // encoded: neceissita' dell'encoding stile URI [boolean] [default:false]
    // per annullare l'utilizzo di una delle variabile, per utilizzare le successive, e' sufficiente settarla a null
    // ex. setCookie("prova","test",null,null,null,true);
    setCookie(name, va, ex, dom, path, encoded) {
        try {
            if (!this.exist(name, _tstr) || (!this.exist(va, _tstr) && !this.exist(va, _tnum))) return !1;
            if (!this.exist(encoded, _tbool)) encoded = !1;
            if (this.exist(ex, _tnum)) {
                const d = new Date();

                d.setTime(d.getTime() + ex * 24 * 60 * 60 * 1000);
                ex = '; expires=' + d.toGMTString() + ';';
            } else {
                ex = ';';
            }

            if (encoded) va = encodeURIComponent(va);
            let _co = name + '=' + va;

            _co += ex;
            if (this.valued(dom)) _co += 'domain=' + dom + ';';
            _co += this.valued(path) ? 'path=' + path + ';' : 'path=/;';
            document.cookie = _co;

            return !0;
        } catch (_) {
            return !1;
        }
    },

    removeCookie(name) {
        document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT;';
    },

    getLocalStorage(name) {
        if (arguments.length < 1) throw new Error('getLocalStorage needs 1 argument no given.');

        try {
            const x = localStorage.getItem(name);

            return x;
        } catch (_) {
            return null;
        }
    },

    setLocalStorage(name, v) {
        if (arguments.length < 2) throw new Error('setLocalStorage needs 2 arguments ' + arguments.length + ' given.');

        try {
            localStorage.setItem(name, v);
        } catch (_) {
            throw new Error("Localstorage non e' attivo!");
        }
    },

    removeLocalStorage(name) {
        if (arguments.length < 1) throw new Error('getLocalStorage needs 1 argument no given.');

        try {
            localStorage.removeItem(name);
        } catch (_) {
            throw new Error("Localstorage non e' attivo!");
        }
    },

    setStoreItem(name, va, cookieOpt) {
        if (arguments.length < 2) throw new Error('setStoreItem needs 2 arguments ' + arguments.length + ' given.');

        if (!this.exist(cookieOpt, _tstr) || !this.exist(cookieOpt, _tstr)) throw new Error('setStoreItem arguments must be string.');

        if (this.exist(localStorage)) return this.setLocalStorage(name, va);

        if (!this.valid(cookieOpt)) return this.setCookie(name, va);

        this.setCookie(
            name,
            va,
            this.exist(cookieOpt.ex) ? cookieOpt.ex : null,
            this.exist(cookieOpt.dom) ? cookieOpt.dom : null,
            this.exist(cookieOpt.path) ? cookieOpt.path : null,
            this.exist(cookieOpt.encoded) ? cookieOpt.encoded : null
        );
    },

    store(name, va, cookieOpt) {
        if (!this.exist(name, _tstr)) throw new Error('store 1th argument must be a string.');
        if (arguments.length === 1) {
            if (this.exist(localStorage)) return this.getLocalStorage(name);

            return this.setCookie(name);
        }

        if (!this.exist(va, _tstr)) throw new Error('setStoreItem arguments must be string.');
        if (this.exist(localStorage)) return this.setLocalStorage(name, va);
        if (!this.valued(cookieOpt)) return this.setCookie(name, va);
        this.setCookie(
            name,
            va,
            this.exist(cookieOpt.ex) ? cookieOpt.ex : null,
            this.exist(cookieOpt.dom) ? cookieOpt.dom : null,
            this.exist(cookieOpt.path) ? cookieOpt.path : null,
            this.exist(cookieOpt.encoded) ? cookieOpt.encoded : null
        );
    },

    storeRemove(name) {
        if (!this.exist(name, _tstr)) throw new Error('store 1th argument must be a string.');
        if (this.exist(localStorage)) {
            this.removeLocalStorage(name);
        } else {
            this.removeCookie(name);
        }
    },

    getElement(selector, scope) {
        scope = scope ? scope : document;
        const domEl = [];

        Array.prototype.forEach.call(scope.querySelectorAll(selector), (domElement) => {
            domEl.push(domElement);
        });

        return domEl;
    },

    cleanCharacters(str) {
        if (str === null || str === '') {
            return '';
        }

        str = str.toString();
        const PATTERN = /[^\x20\x2D0-9A-Z\x5Fa-z\xC0-\xD6\xD8-\xF6\xF8-\xFF]/g;

        return str.replace(PATTERN, ' ');
    },

    getMeta(name) {
        const metas = document.getElementsByTagName('meta');

        for (let i = 0; i < metas.length; i++) {
            if (metas[i].getAttribute('name') === name) {
                return metas[i].getAttribute('content');
            }

            if (metas[i].getAttribute('property') === name) {
                return metas[i].getAttribute('content');
            }
        }

        return null;
    },
    getQueryParamValue(nomeQueryParam) {
        const urlParams = new URLSearchParams(window.location.search);

        if (urlParams.has(nomeQueryParam)) {
            return urlParams.get(nomeQueryParam);
        }

        return '';
    },
};
